module.exports = __webpack_public_path__ + "static/img/two-piece-2.4c2e547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/two-piece-2.jpg
// module id = V+ZM
// module chunks = 1